export class GcpSubnetPerRegion {
    'region';
    'subnetName';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSubnetPerRegion.attributeTypeMap;
    }
    constructor() {
    }
}
